export default {"src":"/_next/static/image/src/components/icons/min/add-min-pin.c25ca4c21b5b07cafce62a6d1835cc07.svg","height":36,"width":26};